require('scroll-lock/scroll-lock');
'use strict';

var toggle;
var searchInputMobile;
var searchInputDesktop;

var setup = function () {

    toggle = document.getElementById('nav__toggle');
    searchInputMobile = document.getElementById('search-input-mobile');
    searchInputDesktop = document.getElementById('search-input-desktop');
    toggle.addEventListener('change', function () {
        if (this.checked) {
            document.documentElement.classList.add('no-scroll');
        }
        else {
            document.documentElement.classList.remove('no-scroll');
        }
    });


    document.addEventListener("touchstart", function () {
    }, true);


    scrollLock(document.querySelector('.nav__wrapper'));
    window.addEventListener('resize', resize);
};

var resize = function () {
    if (toggle.checked) {
        document.documentElement.classList.add('no-scroll');
        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if(width > 1199) {
            toggle.checked = false;
            document.documentElement.classList.remove('no-scroll');
        }
    } else {
        document.documentElement.classList.remove('no-scroll');
    }

};

window.addEventListener('DOMContentLoaded', setup);
